var _rect, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline0, _polyline1, _polyline10, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstinctiveLabsBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 400,
    fill: "#0A0A0A"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "0,120 80,120 120,80 200,80",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "0,160 60,160 100,120 180,120 220,80",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "0,200 40,200 80,160 140,160",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.3
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "0,80 60,80 80,60",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "600,60 700,60 740,100 820,100 860,60 1024,60",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "700,100 780,100 820,60",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.3
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "500,80 580,80 620,40 700,40",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "0,300 100,300 140,260 240,260",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "0,340 80,340 120,300 200,300 240,340 320,340",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _polyline0 || (_polyline0 = /*#__PURE__*/React.createElement("polyline", {
    points: "60,380 140,380 180,340",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.3
  })), _polyline1 || (_polyline1 = /*#__PURE__*/React.createElement("polyline", {
    points: "600,340 700,340 740,300 840,300 880,340 1024,340",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "680,380 760,380 800,340",
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1.5,
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 904,
    height: 320,
    fill: "none",
    stroke: "#5EF2A0",
    strokeWidth: 1,
    opacity: 0.15,
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstinctiveLabsBanner);
export default __webpack_public_path__ + "static/media/instinctive-labs-banner.8332f70b291b0f5861aed05332164042.svg";
export { ForwardRef as ReactComponent };